var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('icon-book',{staticClass:"has-text-normal"}),_vm._v(" "),_c('document-title',{attrs:{"document":_vm.book}}),_vm._v(",\n  "),_c('em',{staticClass:"has-text-normal"},[_vm._v(_vm._s(_vm.book.author))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }